import { useTranslation } from 'react-i18next';
import { getHrInformationOptions } from '../constants/hrInformationReports';

export default function HrInformationHeading({
    selectedReport,
    onReportChange,
    onExecute,
    executeLoading = false,
}) {
    const { t } = useTranslation();
    const hrInformationOptions = getHrInformationOptions(t);

    return (
        <div className="flex-column gap-10">
            <h1 className="text-center">{t('staff.hrInformation.title')}</h1>
            <div className="flex-column gap-10">
                <select
                    className="small-select width-100"
                    value={selectedReport}
                    onChange={(e) => onReportChange(e.target.value)}
                >
                    <option value="">{t('common.select')}</option>
                    {hrInformationOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <div className="checkbox-wrapper-start title-checkbox justify-content-between">
                    <div className="flex-row gap-10">
                        <input className="form-checkbox" type="checkbox" name="saveReport" id="saveReport" />
                        <span className="span-bold">{t('staff.hrInformation.saveReport')}</span>
                    </div>
                    <button
                        type="button"
                        className="form-btn btn-blue"
                        onClick={onExecute}
                        disabled={!selectedReport || executeLoading}
                    >
                        {executeLoading ? t('common.generating') : t('common.execute')}
                    </button>
                </div>
            </div>
        </div>
    );
}
